import Description from './Description.js';

export default Description;
